import { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { useAppSelector } from "../../../redux/hooks";
import { formatNumber, formatCurrency, formatPercent } from "utils/formatNumber";
import ReactTable from "react-table-6";
import ReactTablePagination from "components/custom/growth/ProductsCVTablePagination";
import useColumnSelector from "hooks/useColumnSelector";
import moment from "moment";
import DownloadReport from "modules/perf_reports/DownloadReport";

export function MetricDebug({ filters, dashboardData }) {
  const [colToggle] = useState();
  const tableRef = useRef();
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);

  const [columns, columnSelectorProps] = useColumnSelector(
    () => {
      const columns = [
        {
          id: "Date",
          label: "Date",
          key: "name",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "name",
          Cell: (props) => {
            return <span>{moment(props.value).format("MMM DD YYYY")}</span>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>Date</span>
            </div>
          ),
        },
        {
          id: "target_sales",
          label: "For. Sales",
          key: "target_sales",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center", width: "1000px" },
          style: { textAlign: "center" },
          accessor: "target_sales",
          Cell: (props) => <span>{formatCurrency(props.value, marketPlace)}</span>,
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>For. Sales</span>
            </div>
          ),
        },
        {
          id: "total_sales",
          label: "Actual Sales",
          key: "total_sales",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "total_sales",
          Cell: (props) => <span>{formatCurrency(props.value, marketPlace)}</span>,
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>Actual Sales</span>
            </div>
          ),
        },
        {
          id: "inc_cashflow",
          label: "Cashflow",
          key: "inc_cashflow",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "inc_cashflow",
          Cell: (props) => <span>{formatCurrency(props.value, marketPlace)}</span>,
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>Cashflow</span>
            </div>
          ),
        },
        {
          id: "value",
          label: "Contribution",
          key: "value",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center", borderRight: "1px solid #555" },
          accessor: "value",
          Cell: (props) => <span>{formatCurrency(props.value, marketPlace)}</span>,
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>Contribution</span>
            </div>
          ),
        },
        {
          id: "inc_contribution",
          label: "Contribution",
          key: "inc_contribution",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center", borderRight: "1px solid #555" },
          accessor: "inc_contribution",
          Cell: (props) => <span>{formatCurrency(props.value, marketPlace)}</span>,
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>Inc. Contribution</span>
            </div>
          ),
        },
        {
          id: "reference_price",
          label: "Ref. Price",
          key: "reference_price",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "reference_price",
          Cell(props) {
            return <div>{formatCurrency(props.value, marketPlace)}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>Ref. Price</span>
            </div>
          ),
        },
        {
          id: "asp",
          label: "ASP",
          key: "asp",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "asp",
          Cell(props) {
            return <div>{formatCurrency(props.value, marketPlace)}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>ASP</span>
            </div>
          ),
        },
        {
          id: "inc_price",
          label: "+/-",
          key: "inc_price",

          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center", borderRight: "1px solid #555" },
          accessor: "inc_price",
          Cell(props) {
            return <div>{formatCurrency(props.value, marketPlace)}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>+/-</span>
            </div>
          ),
        },
        {
          id: "target_units",
          label: "For. Units",
          key: "target_units",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "target_units",
          Cell(props) {
            return <div>{formatNumber(props.value, { decimalPlaces: 0 })}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>For. Units</span>
            </div>
          ),
        },
        {
          id: "total_units",
          label: "Actual Units",
          key: "total_units",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "total_units",
          Cell(props) {
            return <div>{formatNumber(props.value, { decimalPlaces: 0 })}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>Actual Units</span>
            </div>
          ),
        },
        {
          id: "inc_units",
          label: "+/-",
          key: "inc_units",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center", borderRight: "1px solid #555" },
          accessor: "inc_units",
          Cell(props) {
            return <div className="text-center">{formatNumber(props.value, { decimalPlaces: 0 })}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>+/-</span>
            </div>
          ),
        },
        {
          id: "page_views",
          label: "Page Views",
          key: "page_views",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "page_views",
          Cell(props) {
            return <div>{formatNumber(props.value, { decimalPlaces: 0 })}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>Page Views</span>
            </div>
          ),
        },
        {
          id: "reference_cr",
          label: "Ref. CR",
          key: "reference_cr",
          headerClassName: "text-center",
          headerStyle: { textAlign: "center" },
          style: { textAlign: "center" },
          accessor: "reference_cr",
          Cell(props) {
            return <div>{formatPercent(props.value, 2)}</div>;
          },
          Header: () => (
            <div className="text-center" style={{ width: "100px" }}>
              <span>Ref. CR</span>
            </div>
          ),
        },
      ];

      return columns;
    },
    [colToggle],
    "metric_debug",
  );

  return (
    <Row>
      <Col>
        <div className="table-responsive">
          <ReactTable
            ref={tableRef}
            data={dashboardData.date}
            className="pricing-table"
            PaginationComponent={(props) => {
              return (
                <ReactTablePagination
                  {...props}
                  showFilters={false}
                  style={{ marginBottom: "2rem" }}
                  hideFilters={true}
                  columnSelectorProps={columnSelectorProps}
                  hideSearch={true}
                />
              );
            }}
            defaultPageSize={20}
            // Below is needed to eliminate the no data message that covers table headers if no data to render
            NoDataComponent={() => null}
            minRows={0}
            showPaginationTop
            showPaginationBottom={false}
            filterable={false}
            columns={columns}
          />
        </div>
      </Col>
      <Col xs={6} className="text-start mt-5">
        <DownloadReport
          url_path={``}
          filters={filters}
          report_dl=""
          buttonText="Download Report"
          endpoint={`/pricing/dashboard_v4_stats`}
          type="csv"
        />
      </Col>
      <Col xs={6} className="text-end mt-5">
        <a
          href="https://trellis-website.s3.us-west-2.amazonaws.com/Dynamic+Pricing+Metrics.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <button className="btn btn-primary">Download Metric Documentation</button>
        </a>
      </Col>
    </Row>
  );
}
